import options from './WidgetOptions.js';
import http from './Http.js';

export default {
    searchAgents: function (searchTerm) {
        return http.get(options.apiEndpoint() + '/Agent?take=30&search=' + searchTerm);
    }
};